/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Source_VpedalInputs */



/**
* | output |
* | --- |
* | "vPedal (Browser API)" |
*
* @param {Options_Pedal_Source_VpedalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_source_vpedal = /** @type {((inputs?: Options_Pedal_Source_VpedalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Source_VpedalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "de") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "it") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "es") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("vPedal (Browser API)")
	return /** @type {LocalizedString} */ ("vPedal (Browser API)")
});